import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ApiService from "../../api/api.service";
import "./custom-landing.scss";
import { StoreState } from "../../store/store.state";
import {
  getBranding,
  getMerchandiseCategoryList,
  getRoutes,
} from "../../store/appInfo/getters";
import PageLoader from "../../commons/components/Loader/PageLoader";
import FunLayout from "./LayoutViews/Fun";
import GrandLayout from "./LayoutViews/Grand/Layout";
import CasualLayout from "./LayoutViews/Casual/Layout";
import SimpleLayout from "./LayoutViews/Simple/Layout";
import UserJourney from "./UserJourney";
import { defaultCustomUrl } from "../../utils/helpers";
import { setUserJourneyState } from "../../store/appInfo/actions";

interface CustomLandingProps {
  history: any;
  custom_url: String;
  custom_route: String;
  isLoggedIn: boolean;
  branding: any;
  routes: any;
  setUserJourneyState: any;
  selectedCountryName: any;
  merchandiseCategoryList: any;
}

interface CustomLandingState {
  landingSettings: any;
  isLoading: boolean;
  transitionStyle: any;
  renderUserJourney: any;
}

class CustomLanding extends React.Component<
  CustomLandingProps,
  CustomLandingState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      landingSettings: {
        logoStatus: 1,
        logo: "https://res.cloudinary.com/dyyjph6kx/image/upload/v1633439365/store/Logo/xoxoday-full.svg",
        titleStatus: 1,
        title: "Hello hemanth",
        titleColour: "#252A31",
        descriptionStatus: 1,
        description:
          "We have a little something for you as a token of appreciation.",
        descriptionColour: "#252A31",
        imageStatus: 1,
        image:
          "https://res.cloudinary.com/dyyjph6kx/image/upload/v1633595901/store/admin/campaign/campaign-grand.png",
        buttonStatus: 1,
        buttonText: "Claim your reward",
        buttonColour: "#252A31",
        buttonTextColour: "#FFFFFF",
        howToRedeem: 1,
      },
      isLoading: true,
      transitionStyle: {},
      renderUserJourney: false,
    };
  }

  componentDidMount() {
    const {
      branding: { custom_url = "/marketplace" } = {},
      routes,
      history,
      selectedCountryName,
      merchandiseCategoryList,
    } = this.props;
    this.getLandingDetails();
    const logoRedirectionFrom = new URLSearchParams(window.location.search).has(
      "fromLogo"
    );
    if (!logoRedirectionFrom) {
      this.props.setUserJourneyState("");
    }
    if (logoRedirectionFrom) {
      const redirectRoute = defaultCustomUrl(custom_url);
      if (routes.includes("merchandises") && selectedCountryName === "India") {
        history.push(`${redirectRoute}/merchandises`);
      } else if (routes?.includes("vouchers")) {
        history.push(`${redirectRoute}/vouchers`);
      } else if (routes?.includes("experiences")) {
        history.push(`${redirectRoute}/experiences`);
      }
    }
  }

  getLayoutFromKey = (settingsData: any) => {
    const { landingSettings: { layoutKey = "fun" } = {} } = this.state;
    switch (layoutKey) {
      case "fun":
        return <FunLayout landingSettings={settingsData} />;
      case "casual":
        return <CasualLayout landingSettings={settingsData} />;
      case "grand":
        return <GrandLayout landingSettings={settingsData} />;
      case "simple":
        return <SimpleLayout landingSettings={settingsData} />;
      default:
        break;
    }
  };

  handleAutoRedirect = (redirectRoute: any) => {
    setTimeout(() => {
      this.setState({
        transitionStyle: { transition: "opacity 2s", opacity: 0 },
      });
      setTimeout(() => {
        this.redirectToAccessibleRoute(redirectRoute);
      }, 2000);
    }, 4000);
  };

  getLandingDetails = () => {
    this.setState({ isLoading: true });
    const { branding: { custom_url = "/marketplace" } = {} } = this.props;

    const data = ApiService.getLandingDetails(
      custom_url,
      this.props.isLoggedIn
    );
    const redirectRoute = defaultCustomUrl(custom_url);
    data.then((data: any) => {
      if (
        data &&
        data.getLandingDetails &&
        data.getLandingDetails.success &&
        data.getLandingDetails.success === 1 &&
        data.getLandingDetails.campaignLandingDetails &&
        Object.values(data.getLandingDetails.campaignLandingDetails).length >
          0 &&
        Object.values(data.getLandingDetails.campaignLandingDetails).findIndex(
          (item) => item === null
        ) === -1
      ) {
        const finalData = data.getLandingDetails.campaignLandingDetails;
        this.setState({ landingSettings: finalData });
        this.setState({ isLoading: false });
        if (redirectRoute === "/marketplace") {
          this.handleAutoRedirect(redirectRoute);
        }
      } else {
        if (redirectRoute === "/marketplace") {
          this.setState({ isLoading: false, renderUserJourney: true });
        } else {
          this.redirectToAccessibleRoute(redirectRoute);
        }
      }
    });
  };

  redirectToAccessibleRoute = (redirectRoute: string) => {
    const isFromEmailWithQueryParam = new URLSearchParams(
      window.location.search
    ).has("redeem");
    const { history, selectedCountryName, routes } = this.props;
    if (isFromEmailWithQueryParam) {
      this.redirectToXoxoCodeUseCase(redirectRoute);
    } else {
      if (routes.includes("merchandises") && selectedCountryName === "India") {
        history.push(`${redirectRoute}/merchandises`);
      } else if (routes?.includes("vouchers")) {
        history.push(`${redirectRoute}/vouchers`);
      } else if (routes?.includes("experiences")) {
        history.push(`${redirectRoute}/experiences`);
      }
    }
  };

  redirectToXoxoCodeUseCase = (redirectRoute: string) => {
    const { history, selectedCountryName, routes } = this.props;
    if (routes.includes("merchandises") && selectedCountryName === "India") {
      history.push(`${redirectRoute}/merchandises`);
    } else if (routes?.includes("vouchers")) {
      history.push(`${redirectRoute}/vouchers`);
    } else if (routes?.includes("experiences")) {
      history.push(`${redirectRoute}/experiences`);
    }
  };

  redirectToLogin = () => {
    const { branding: { custom_url = "/marketplace" } = {} } = this.props;
    const redirectRoute = defaultCustomUrl(custom_url);
    this.props.history.push({ pathname: `${redirectRoute}/login`, state: "" });
  };

  render() {
    const { branding: { custom_url = "/" } = {} } = this.props;
    const { isLoading, landingSettings, transitionStyle, renderUserJourney } =
      this.state;
    if (isLoading) {
      return <PageLoader />;
    }
    return renderUserJourney ? (
      <UserJourney
        redirectToLogin={() => this.redirectToLogin()}
        custom_url={custom_url}
        redirectToAccessibleRoute={(branding: any) =>
          this.redirectToAccessibleRoute(branding)
        }
        redirectToXoxoCodeUseCase={(branding: any) =>
          this.redirectToXoxoCodeUseCase(branding)
        }
        setUserJourneyState={(useCase: string) =>
          this.props.setUserJourneyState(useCase)
        }
      />
    ) : (
      <div className="landingPage" style={transitionStyle}>
        {this.getLayoutFromKey(landingSettings)}
      </div>
    );
  }
}

const mapStateToProps = ({ appInfo }: StoreState) => ({
  branding: getBranding(appInfo),
  routes: getRoutes(appInfo),
  merchandiseCategoryList: getMerchandiseCategoryList(appInfo),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setUserJourneyState: (userJourneyUseCase: any) =>
        setUserJourneyState(userJourneyUseCase),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CustomLanding);
